import type { IPublicClientApplication } from '@azure/msal-browser'
import type { MenuItem } from 'primereact/menuitem'
import type { LoggedUser } from '../../users/types'
import { useMsal } from '@azure/msal-react'
import { Menubar } from 'primereact/menubar'
import { useNavigate } from 'react-router'
import { paths } from '../../paths'
import { useUserContext } from '../../users/UserContextHook'
import styles from './UserMenu.module.css'

async function signOutClickHandler(instance: IPublicClientApplication, userId: string) {
  if (userId) {
    const logoutRequest = {
      account: instance.getAccount({ homeAccountId: userId }),
      postLogoutRedirectUri: '/',
    }
    await instance.logoutRedirect(logoutRequest)
  }
}

export function UserMenu() {
  const { instance } = useMsal()
  const activeAccount = instance.getActiveAccount()
  const { canManageUsers } = useUserContext()
  const navigate = useNavigate()

  const loggedUser: LoggedUser = {
    isLoggedIn: !!activeAccount,
    data: activeAccount
      ? {
          name: activeAccount.name ?? activeAccount.username,
          userId: activeAccount.homeAccountId,
          canManageUsers,
        }
      : null,
  }

  if (loggedUser.isLoggedIn && loggedUser.data && loggedUser.data.userId) {
    const userId: string = loggedUser.data.userId
    const submenu: MenuItem[] = [
      {
        label: loggedUser.data.name,
        icon: 'pi pi-user',
        items: [
          canManageUsers
            ? {
                label: 'User management',
                icon: 'pi pi-users',
                command: () => {
                  void navigate(paths.userManagement)
                },
              }
            : {},
          {
            label: 'logout',
            icon: 'pi pi-sign-out',
            command: async () => {
              await signOutClickHandler(instance, userId)
            },
          },
        ].filter(item => Object.keys(item).length > 0), // Filter out empty items.
      },
    ]

    return (
      <Menubar model={submenu} className={`bg-white p-0 border-none hover:text-white hover:text-cyan-500 ${styles.userMenu}`} />
    )
  }
}
